import jQuery from 'jquery';
let $ = jQuery;

import "LIBS/jquery.slimscroll.js";
// define EVENTs
import "HSNDIR/Flyout.js";

HSN.Breadbox = function (config) {
    this._container = $('#breadbox');

    if (!Modernizr.touchevents) {
        HSN.Tooltip(this._container.find("[data-tooltip]"));
    }

    var brandsContainer = this._container.find('.brands');

    this._brandsFlyout = new HSN.Flyout({
        trigger: brandsContainer,
        triggerEvent: 1,
        flyout: this._container.find('.brands .flyout'),
        closeClass: 'ir'
    });

    var brandsFlyoutIndicator = $('<div class="indicator ir"></div>');
    this._brandsFlyout.Flyout.append(brandsFlyoutIndicator);

    this._brandsFlyout.Events.On(
        HSN.Flyout.EVENT.BEFORE_OPEN,
        function (flyout) {
            var flyoutOuterHeight = flyout.Flyout.outerHeight();
            var brandsContainerTopOffset = brandsContainer.offset().top;
            var windowScrollTop = $(window).scrollTop();
            var topGap = (brandsContainerTopOffset - windowScrollTop);

            var newPosition = ((flyoutOuterHeight / 2) * -1);

            if (newPosition < (topGap * -1)) {
                newPosition = (topGap * -1);
            }
            else {
                var bottomGap = (($(window).height() + windowScrollTop) - (brandsContainer.outerHeight() + brandsContainerTopOffset));
                if (newPosition + flyoutOuterHeight > bottomGap) {
                    newPosition = ((flyoutOuterHeight - flyout.Trigger.outerHeight() - bottomGap) * -1);
                }
            }

            flyout.Flyout.css({
                top: newPosition
            });

            brandsFlyoutIndicator.css({
                top: ((newPosition * -1) - 3)
            });

            //ADA Code
            var activeTab = $('li.active');
            if (activeTab.length) {
                activeTab[0].children[0].focus();
            }
            $('.flyout').attr('aria-hidden', 'false');
            $('.flyout-trigger').attr('aria-expanded', 'true');


            // This silliness is unfortunately needed to force CSS3Pie to reposition the shim element to the new position.
            flyout.Flyout.removeClass('flyout').addClass('flyout');
        },
        this
    );

    this._brandsFlyout.Events.On(
        HSN.Flyout.EVENT.BEFORE_CLOSE,
        function () {
            var flyoutDiv = $('#breadboxFlyout');
            flyoutDiv.attr('aria-hidden', 'true');
            $('.flyout-trigger').focus();
            $('.flyout-trigger').attr('aria-expanded', 'false');

        },
        this
    );
    //this._application.FlyoutManager.Add(this._brandsFlyout);

    new HSN.TabPanel(this._container.find('.flyout .tabs'), '.tab-items > li > a');

    new HSN.Carousel({
        container: this._container.find('.right ul.product-list'),
        touch: Modernizr.touchevents
    });

    var isTablet = HSN.Instance().DeviceInformation.IsTablet;
    $('.lnav .scroll').filter(function (i, e) {
        // get groups that have a scroll bar; do +1 for IE, otherwise it thinks all sections have a scrollbar
        return $(e).get(0).scrollHeight > ($(e).get(0).clientHeight + 1);
    }).slimScroll({
        alwaysVisible: isTablet,
        color: '#999',
        railColor: '#f2f2f2',
        height: 'none',
        size: '11px',
        wheelStep: isTablet ? 40 : 3,
        opacity: 1,
        railOpacity: 1,
        railVisible: true,
        disableFadeOut: true
    });
    if (!isTablet)
        $('.lnav .slimScrollBar').hide();

};
HSN.Breadbox.prototype =
    {

    };



// WEBPACK FOOTER //
// ./assets/js/HSN/Breadbox.js